/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {APP_SHARED} from '../app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED],
  selector: 'adn-solo-visibility',
  template: `
    <p class="alert alert-warning" *ngIf="(!model || !(model.id || model.length > 0)) && !isNew">
      <span>{{ ('solo.' + transKey) | ogTranslate }}</span>
    </p>
  `
})
export class SoloVisibilityInfoComponent {
  @Input() model: any;
  @Input() isNew: boolean;
  @Input() transKey= 'default';
}
